import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "page-intro-hero" }
const _hoisted_2 = { class: "page-intro-hero__inner" }
const _hoisted_3 = { class: "page-intro-hero__title" }
const _hoisted_4 = {
  key: 0,
  class: "page-intro-hero__subtitle"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.title), 1 /* TEXT */),
      (_ctx.subtitle)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.subtitle), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}